import * as React from "react";
const SvgXcircleG900 = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={18} height={18} fill="none" {...props}>
    <g opacity={0.9}>
      <circle cx={9} cy={9} r={9} fill="#191919" />
      <path stroke="#fff" strokeLinecap="round" strokeLinejoin="round" d="m6 12 6-6M12 12 6 6" />
    </g>
  </svg>
);
export default SvgXcircleG900;
